import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type AuditLogOperationDTO = 'create' | 'update' | 'delete' | 'bulk';

export type AuditLogChangeDTO = {
  path: string;
  kind: 'set' | 'added' | 'removed';
  from?: string;
  to?: string;
};

export type AuditLogEntryDTO = {
  _id: string;
  createdAt: string;
  collectionName: string;
  documentId?: string;
  documentLabel?: string;
  operation: AuditLogOperationDTO;
  actor: { _id?: string; name?: string; email?: string };
  request?: { method?: string; path?: string };
  changes: AuditLogChangeDTO[];
  truncated?: boolean;
  summary?: string;
  affectedCount?: number;
};

export type AuditLogFilters = {
  actorId?: string;
  collectionName?: string;
  documentId?: string;
  operation?: AuditLogOperationDTO;
  path?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
};

export const searchAuditLogs: ApiDescription = {
  endpoint: '/admin/audit-logs',
  method: RequestsMethod.Get,
};

export type SearchAuditLogs = ApiData<
  AuditLogFilters,
  { entries: AuditLogEntryDTO[]; total: number; page: number; limit: number }
>;

export const getAuditLogFilterOptions: ApiDescription = {
  endpoint: '/admin/audit-logs/filters',
  method: RequestsMethod.Get,
};

export type GetAuditLogFilterOptions = ApiData<
  never,
  { collections: string[]; actors: { _id: string; name: string; email: string }[] }
>;
